export const CLARITY_ID_PROD = 'q19yxan0z4';
export const CLARITY_ID_TEST = 'q1cp3n70i2';
